<template>
  <div>
    <swiper
      :options="{
        slidesPerView: 'auto',
        freeMode: true,
        initialSlide: tab - 1,
      }"
      class="swiper"
    >
      <swiper-slide :class="{ active: tab === 1 }">
        <div @click="$router.push({ name: 'Profile' }).catch(() => {})">
          {{ $t("menu.setting.profile") }}
        </div>
      </swiper-slide>
      <swiper-slide :class="{ active: tab === 2 }">
        <div @click="$router.push({ name: 'PasswordChange' }).catch(() => {})">
          {{ $t("title.common.password") }}
        </div>
      </swiper-slide>
      <swiper-slide :class="{ active: tab === 3 }">
        <div @click="$router.push({ name: 'EmailChange' }).catch(() => {})">
          {{ $t("title.common.email") }}
        </div>
      </swiper-slide>
      <swiper-slide :class="{ active: tab === 4 }">
        <div @click="$router.push({ name: 'Option' }).catch(() => {})">
          {{ $t("menu.setting.option") }}
        </div>
      </swiper-slide>
      <swiper-slide :class="{ active: tab === 5 }">
        <div @click="$router.push({ name: 'Notice' }).catch(() => {})">
          {{ $t("menu.setting.owner_notice") }}
        </div>
      </swiper-slide>
    </swiper>
    <ul class="nav nav-pills" id="pills-tab" role="tablist">
      <li class="nav-item" role="presentation">
        <button
          class="nav-link btn-xxl"
          id="pills-1-tab"
          type="button"
          @click="$router.push({ name: 'Profile' }).catch(() => {})"
          :class="{ active: $route.name === 'Profile' }"
        >
          {{ $t("menu.setting.profile") }}
        </button>
      </li>
      <li class="nav-item" role="presentation">
        <button
          class="nav-link btn-xxl"
          id="pills-2-tab"
          type="button"
          @click="$router.push({ name: 'PasswordChange' }).catch(() => {})"
          :class="{ active: $route.name === 'PasswordChange' }"
        >
          {{ $t("title.common.password") }}
        </button>
      </li>
      <li class="nav-item" role="presentation">
        <button
          class="nav-link btn-xxl"
          id="pills-3-tab"
          type="button"
          @click="$router.push({ name: 'EmailChange' }).catch(() => {})"
          :class="{ active: $route.name === 'EmailChange' }"
        >
          {{ $t("title.common.email") }}
        </button>
      </li>
      <li class="nav-item" role="presentation">
        <button
          class="nav-link btn-xxl"
          id="pills-4-tab"
          type="button"
          @click="$router.push({ name: 'Option' }).catch(() => {})"
          :class="{ active: $route.name === 'Option' }"
        >
          {{ $t("menu.setting.option") }}
        </button>
      </li>
      <li class="nav-item" role="presentation">
        <button
          class="nav-link btn-xxl"
          id="pills-5-tab"
          type="button"
          @click="$router.push({ name: 'Notice' }).catch(() => {})"
          :class="{
            active: $route.name === 'Notice' || $route.name === 'NoticeView',
          }"
        >
          {{ $t("menu.setting.owner_notice") }}
        </button>
      </li>
    </ul>
  </div>
</template>

<script>
import "swiper/css/swiper.css";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";

export default {
  name: "Tab",
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      tab_position: 0,
      /*swiperOptions: {
        slidesPerView: 'auto',
        freeMode: true,
        initialSlide: this.tab
      }*/
    };
  },
  computed: {
    tab: function () {
      if (this.$route.name === "Profile") return 1;
      else if (this.$route.name === "PasswordChange") return 2;
      else if (this.$route.name === "EmailChange") return 3;
      else if (this.$route.name === "Option") return 4;
      else return 5;
    },
  },
  setup() {
    const onSwiper = (swiper) => {
      console.log(swiper);
    };
    const onSlideChange = () => {
      console.log("slide change");
    };
    return {
      onSwiper,
      onSlideChange,
    };
  },
};
</script>

<style></style>
